import React, { useState } from 'react';
import { Mail, Phone, MapPin, Check, Loader2 } from 'lucide-react';

function Contact() {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [status, setStatus] = useState('idle');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('submitting');
        
        setTimeout(() => {
            setStatus('success');
            setFormData({ name: '', email: '', message: '' });
            setTimeout(() => setStatus('idle'), 3000);
        }, 1500);
    };

    return (
        <section id="contact" className="py-16 md:py-24 bg-white">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
                <div className="bg-blue-600 rounded-3xl p-6 md:p-12 overflow-hidden relative text-white text-center shadow-2xl shadow-blue-200">
                    <h2 className="text-2xl md:text-3xl font-bold mb-4 relative z-10">Start your project?</h2>
                    <p className="text-blue-100 mb-8 max-w-lg mx-auto relative z-10 text-sm md:text-base">
                        We are ready to help you succeed.
                    </p>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 text-left mb-8 md:mb-12 relative z-10">
                        {[
                            { icon: Mail, title: "Email Us", val: "info@ezems.co.ke" },
                            { icon: Phone, title: "Call Us", val: "+254 101 086 123" },
                            { icon: MapPin, title: "Visit Us", val: "Kilifi, Kenya" }
                        ].map((c, i) => (
                            <div key={i} className="bg-white/10 backdrop-blur-md p-4 md:p-6 rounded-xl hover:bg-white/20 transition-colors">
                                <c.icon className="mb-3 text-blue-200" size={20} />
                                <h4 className="font-bold text-sm">{c.title}</h4>
                                <p className="text-xs text-blue-100 mt-1 break-words font-mono">{c.val}</p>
                            </div>
                        ))}
                    </div>
                    
                    <form onSubmit={handleSubmit} className="max-w-md mx-auto bg-white rounded-2xl p-6 text-slate-900 shadow-xl relative z-10 text-left space-y-4">
                        <div>
                            <label className="text-xs font-bold text-slate-500 mb-1 block">Full Name</label>
                            <input 
                                required 
                                name="name" 
                                onChange={(e) => setFormData({...formData, name: e.target.value})} 
                                value={formData.name} 
                                className="w-full px-4 py-3 bg-slate-50 rounded-lg border border-slate-200 text-sm outline-none focus:ring-2 focus:ring-blue-500" 
                            />
                        </div>
                        
                        <div>
                            <label className="text-xs font-bold text-slate-500 mb-1 block">Email</label>
                            <input 
                                required 
                                name="email" 
                                type="email" 
                                onChange={(e) => setFormData({...formData, email: e.target.value})} 
                                value={formData.email} 
                                className="w-full px-4 py-3 bg-slate-50 rounded-lg border border-slate-200 text-sm outline-none focus:ring-2 focus:ring-blue-500" 
                            />
                        </div>
                        
                        <div>
                            <label className="text-xs font-bold text-slate-500 mb-1 block">Message</label>
                            <textarea 
                                required 
                                name="message" 
                                rows="3" 
                                onChange={(e) => setFormData({...formData, message: e.target.value})} 
                                value={formData.message} 
                                className="w-full px-4 py-3 bg-slate-50 rounded-lg border border-slate-200 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                            ></textarea>
                        </div>
                        
                        {status === 'success' && (
                            <div className="text-green-600 text-sm flex gap-2">
                                <Check size={16}/> Message Sent!
                            </div>
                        )}
                        
                        <button 
                            type="submit" 
                            disabled={status === 'submitting'} 
                            className="w-full py-3 bg-slate-900 text-white font-bold rounded-lg hover:bg-blue-800 transition-colors flex items-center justify-center gap-2"
                        >
                            {status === 'submitting' ? <><Loader2 className="animate-spin" size={18} /> Sending...</> : "Send Message"}
                        </button>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default Contact;